<template>
  <section id="home" class="page-box">
    <el-image :src="require('@/assets/images/slide.png')"></el-image>
    <div class="organization-logo">
      <el-image
        :src="require('@/assets/images/logo-organization.png')"
      ></el-image>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeComponent",
  props: {
    msg: String,
  },
};
</script>
